module.exports = __webpack_public_path__ + "static/media/Torkoal_gaussian2.5e32d23f.png";